import { Dialog, DialogConfig, DialogRef } from "@angular/cdk/dialog";
import { ComponentType } from "@angular/cdk/portal";
import { inject, Injectable, InputSignal } from "@angular/core";

export type ComponentInput<T> = {
  [K in keyof T]: T[K] extends InputSignal<infer V> ? V : never;
};

export type ModalConfig<C, R> = DialogConfig<ComponentInput<C>, DialogRef<R, C>> & {
  inputs?: Partial<ComponentInput<C>>;
};

@Injectable({
  providedIn: "root",
})
export class ModalService {
  public dialog = inject(Dialog);

  public open<C, R = unknown>(component: ComponentType<C>, config: ModalConfig<C, R>): DialogRef<R, C> {
    const panelClass = ["bg-base-100", "rounded"];
    if (Array.isArray(config.panelClass)) {
      panelClass.push(...config.panelClass);
    } else if (typeof config.panelClass === "string") {
      panelClass.push(config.panelClass);
    }
    const ref = this.dialog.open(component, {
      minWidth: "400px",
      maxWidth: "800px",
      minHeight: "400px",
      maxHeight: "80vh",
      ...config,
      panelClass,
    });
    if (config.inputs) {
      for (const key in config.inputs) {
        ref.componentRef.setInput(key, config.inputs[key]);
      }
    }
    return ref;
  }
}
